// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__d1eoz","summary":"CartItem_summary__5fhdm","price":"CartItem_price__3Ffa-","amount":"CartItem_amount__1goFU","actions":"CartItem_actions__1dM6f"};